import type { AdminCategoryDTO } from '@dfq/shared/types/category';

/**
 * One node of a flattened category tree — enough to render an indented
 * option in a multi-select without the consumer re-walking `children`.
 */
export interface FlatCategoryOption {
  id: number;
  slug: string;
  name: string;
  /** 0 for a top-level category, 1 for its direct children, etc. */
  depth: number;
}

/**
 * Flatten `GET /admin/categories?as=tree`'s nested `children` shape into an
 * ordered, depth-annotated list — pre-order so a parent always precedes its
 * children, suited to rendering a hierarchical checkbox list top-to-bottom.
 * CON-PROD-101.
 */
export function flattenCategoryTree(
  categories: readonly AdminCategoryDTO[],
  depth = 0,
): FlatCategoryOption[] {
  const result: FlatCategoryOption[] = [];

  for (const category of categories) {
    result.push({ id: category.id, slug: category.slug, name: category.name, depth });

    if (category.children.length > 0) {
      result.push(...flattenCategoryTree(category.children, depth + 1));
    }
  }

  return result;
}
